import RoutesMap from "../../route_control/RouteControl"
import {
    CourseList,
    AddCourse,
    UpdateCourse,
    CountryList,
    CityList,
    StateList,
    DistrictList,
    TehsilList,
    SessionList,
    SemesterList,
    StudentList,
    AddStudent,
    UpdateStudent,
    StudentDetails,
    SubjectList,
    DesignationList,
    DepartmentList,
    SlotList,
    AddSlot,
    UpdateSlot,
    MasterPaymentList,
    StaffList,
    AddStaff,
    UpdateStaff,
    CouponList,
    CouponDetails
} from "../../pages/master"

export const MasterImport = {
    RoutesMap,
    CourseList,
    AddCourse,
    UpdateCourse,
    CountryList,
    CityList,
    StateList,
    DistrictList,
    TehsilList,
    SessionList,
    SemesterList,
    StudentList,
    AddStudent,
    UpdateStudent,
    StudentDetails,
    SubjectList,
    DesignationList,
    DepartmentList,
    SlotList,
    AddSlot,
    UpdateSlot,
    MasterPaymentList,
    StaffList,
    AddStaff,
    UpdateStaff,
    CouponList,
    CouponDetails
}
